export default __webpack_public_path__ + "static/media/ISMI.0c7436ae.pdf";